import Vue from 'vue'

const SLOW_RESPONSE_THRESHOLD_MS = 3000

const state = Vue.observable({
  online: typeof navigator === 'undefined' ? true : navigator.onLine,
  status: typeof navigator === 'undefined' || navigator.onLine ? 'online' : 'offline',
  lastLatencyMs: null,
  lastCheckedAt: null,
  lastFailureAt: null,
})

const updateStatusFromOnlineFlag = () => {
  state.online = typeof navigator === 'undefined' ? true : navigator.onLine
  state.status = state.online ? 'online' : 'offline'
}

const markRequestSuccess = durationMs => {
  state.online = true
  state.lastCheckedAt = new Date()
  state.lastLatencyMs = Number.isFinite(durationMs) ? Math.round(durationMs) : null
  state.status = state.lastLatencyMs !== null && state.lastLatencyMs >= SLOW_RESPONSE_THRESHOLD_MS
    ? 'slow'
    : 'online'
}

const markRequestFailure = () => {
  state.online = typeof navigator === 'undefined' ? false : navigator.onLine
  state.lastFailureAt = new Date()
  state.status = state.online ? 'unstable' : 'offline'
}

const isNetworkError = error => {
  if (!error) {
    return false
  }

  return error.isNetworkError === true || (!error.response && (!!error.request || error.message === 'Network Error'))
}

if (typeof window !== 'undefined') {
  window.addEventListener('online', updateStatusFromOnlineFlag)
  window.addEventListener('offline', updateStatusFromOnlineFlag)
}

export {
  state as networkStatus,
  isNetworkError,
  markRequestFailure,
  markRequestSuccess,
}
